import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import getUserPermissions from '../../../api/services/getUserPermission.service';
import GetUserProfile from '../../../api/services/getUserProfile.service';

const initialState = {
    value: {},
    permissions: {},
    userRoles: {},
    loading: false,
    error: false,
    childData: [],
    particularChild: [],
    ethinicity: [],
    child: {},
};

type GetUserDetailsPayload = {
    profileUserId: any;
    profileOrgId: any;
};
type getParticularChildPayload = {
    id: any;
};

type payload = {
    childId: any;
};
export const getUserDetailsCall = createAsyncThunk(
    'getUserDetailsCall',
    async (payload: GetUserDetailsPayload, { rejectWithValue }) => {
        try {
            const res = await GetUserProfile.userProfileData(
                payload.profileUserId,
                payload.profileOrgId
            );
            return res.data;
        } catch (err) {
            rejectWithValue('Error in Response');
        }
    }
);
export const userChildByIdCall = createAsyncThunk(
    'userChildByIdCall',
    async (payload: getParticularChildPayload, { rejectWithValue }) => {
        try {
            const res = await GetUserProfile.userchildById(payload);
            return res.data;
        } catch (err) {
            rejectWithValue('Error in Response');
        }
    }
);
export const getUserDetailsPermissionCall = createAsyncThunk(
    'getUserDetailsPermissionCall',
    async (payload: GetUserDetailsPayload, { rejectWithValue }) => {
        try {
            const res = await getUserPermissions.userPermission(
                payload.profileUserId,
                payload.profileOrgId
            );
            return {
                userRoles: res.data,
                loginData: {},
            };
        } catch (err) {
            rejectWithValue('Error in Response');
        }
    }
);
export const getUserPermissionByChildIdCall = createAsyncThunk(
    'getUserDetailsPermissionCall',
    async (payload: payload, { rejectWithValue }) => {
        try {
            const res = await getUserPermissions.userPermissionBychildId(
                payload.childId
            );
            return {
                userRoles: res.data,
                loginData: {},
            };
        } catch (err) {
            rejectWithValue('Error in Response');
        }
    }
);

export const getAllChild = createAsyncThunk(
    'getAllChild',
    async (_, { rejectWithValue }) => {
        try {
            const res = await GetUserProfile.getAllChild();
            return res.data;
        } catch (err) {
            rejectWithValue('Error in Response');
        }
    }
);
export const getParticularChild = createAsyncThunk(
    'getParticularChild',
    async (payload: getParticularChildPayload, { rejectWithValue }) => {
        try {
            const res = await GetUserProfile.getParticularChild(payload);
            return res.data;
        } catch (err) {
            rejectWithValue('Error in Response');
        }
    }
);
export const getEthinicity = createAsyncThunk(
    'getEthinicity',
    async (_, { rejectWithValue }) => {
        try {
            const res = await GetUserProfile.getEthinicity();
            return res.data;
        } catch (err) {
            rejectWithValue('Error in Response');
        }
    }
);

const userDetailsSlice = createSlice({
    name: 'userDetails',
    initialState,
    reducers: {
        savingUserDetails: (state, action) => {
            state.value = { ...action.payload };
        },
        clearUserDetails: (state) => {
            state.value = {};
            state.permissions = {};
            state.userRoles = {};
        },
        clearChildData: (state) => {
            state.particularChild = [];
        },
        clearChildDetails: (state) => {
            state.child = {};
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getUserDetailsCall.pending, () => {})
            .addCase(getUserDetailsCall.fulfilled, (state: any, action) => {
                state.value = action.payload;
                state.loading = false;
            })
            .addCase(getUserDetailsCall.rejected, (state: any) => {
                state.error = true;
                state.loading = false;
            })
            .addCase(getUserDetailsPermissionCall.pending, (state: any) => {
                state.loading = true;
            })
            .addCase(
                getUserDetailsPermissionCall.fulfilled,
                (state: any, action: any) => {
                    state.userRoles = { ...action?.payload?.userRoles };
                    state.permissions = { ...action?.payload?.loginData };
                    state.loading = false;
                }
            )
            .addCase(userChildByIdCall.fulfilled, (state: any, action) => {
                state.child = action.payload;
                state.loading = false;
            })
            .addCase(getUserDetailsPermissionCall.rejected, (state) => {
                state.loading = false;
            })
            .addCase(getAllChild.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAllChild.fulfilled, (state: any, action) => {
                state.childData = action.payload;
                state.loading = false;
            })
            .addCase(getAllChild.rejected, (state: any) => {
                state.error = true;
                state.loading = false;
            })
            .addCase(getParticularChild.pending, (state) => {
                state.loading = true;
            })
            .addCase(getParticularChild.fulfilled, (state: any, action) => {
                state.particularChild = action.payload;
                state.loading = false;
            })
            .addCase(getParticularChild.rejected, (state: any) => {
                state.error = true;
                state.loading = false;
            })
            .addCase(getEthinicity.pending, (state) => {
                state.loading = true;
            })
            .addCase(getEthinicity.fulfilled, (state: any, action) => {
                state.ethinicity = action.payload;
                state.loading = false;
            })
            .addCase(getEthinicity.rejected, (state: any) => {
                state.error = true;
                state.loading = false;
            });
    },
});
export const {
    savingUserDetails,
    clearUserDetails,
    clearChildData,
    clearChildDetails,
} = userDetailsSlice.actions;

export default userDetailsSlice.reducer;
